import React from "react";
import { useSelector } from "react-redux";
import { ROUTES } from "routes/routePaths";
import EmptyDashboard from "./EmptyDashboard";

import { Navigate } from "react-router-dom";
import { permissions } from "utils/permissions";
import { hasPermission } from "utils/helper";
import "./style.scss";

const Dashboard = () => {
  const { user } = useSelector((state) => state.user);

  const userType = user?.user_type;
  const onBoardingStatus = user?.onboarding_state;
  const status = user?.status;

  const {
    dashboardTerminalStats,
    dashboardOnboardingStats,
    agentOnboardingPending,
    agentOnboardingStart,
  } = ROUTES;

  const { canSeeTerminalStaistics, canSeeOnboardingStaistics } = permissions;

  if (userType.toLowerCase().includes("admin")) {
    if (hasPermission(canSeeTerminalStaistics, user.authorities)) {
      return <Navigate to={dashboardTerminalStats} />;
    } else if (hasPermission(canSeeOnboardingStaistics, user.authorities)) {
      return <Navigate to={dashboardOnboardingStats} />;
    } else return <EmptyDashboard />;
  }

  if (status === 1) return <Navigate to={dashboardTerminalStats} />;

  if (onBoardingStatus === 9) return <Navigate to={agentOnboardingPending} />;

  return <Navigate to={agentOnboardingStart} />;
};

export default Dashboard;
